module.exports = __webpack_public_path__ + "static/img/stJohns2.c24c4b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/stJohns2.jpg
// module id = 136
// module chunks = 9